import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { addFolder } from '../../../../api/data-project-folder';

interface CreateFolderModalProps {
  requestId?: string;
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  projectId: string;
  parentFolderId?: number;
  viewId?: number;
}

const CreateFolderModal: React.FC<CreateFolderModalProps> = ({
  requestId,
  visible,
  onCancel,
  onSuccess,
  projectId,
  parentFolderId,
  viewId
}) => {
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = async () => {
    setConfirmLoading(true);
    try {
      const values = await form.validateFields();
      const params = {
        folderName: values.folderName,
        parentId: parentFolderId || null,
        projectId: projectId,
        viewId: viewId
      };

      await addFolder(params, requestId);
      message.success('新建文件夹成功');
      form.resetFields();
      onSuccess();
      setConfirmLoading(false);
    } catch (error) {
      setConfirmLoading(false);
      message.error('新建文件夹失败');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="新建文件夹"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
      width={600}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="文件夹名称"
          name="folderName"
          rules={[{ required: true, message: '请输入文件夹名称' }]}
        >
          <Input placeholder="请输入文件夹名称" onPressEnter={handleOk} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateFolderModal; 
